import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import ConfirmDeleteModel from "../../../themes/elements/ConfirmDeleteModel";
import useDeleteSurveyQuestionnaireApiService from "../services/api/DeleteSurveyQuestionnaireApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type DeleteSurveyQuestionButtonProps = {
  surveyId: number;
  id: number;
  onDone: () => void;
};

const DeleteSurveyQuestionButton: React.FC<DeleteSurveyQuestionButtonProps> = ({
  id,
  surveyId,
  onDone,
}) => {
  const [opened, setOpened] = useState(false);
  const { isLoading, isError, error, isSuccess, mutate } =
    useDeleteSurveyQuestionnaireApiService();
  const { showToast } = useToasts();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "survey_question_delete_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      queryClient
        .refetchQueries(["SurveyDetailsApiService", surveyId])
        .then(() => onDone())
        .catch(() =>
          showToast({
            strapiId: "survey_question_refreshing_failed",
            data: { message: "Failed to update questions" },
          })
        );

      setOpened(false);

      showToast({ strapiId: "survey_question_delete_success" });
    }
  }, [isSuccess]);

  return (
    <>
      {opened && (
        <ConfirmDeleteModel
          isLoading={isLoading}
          label="question"
          onClose={() => setOpened(false)}
          onConfirm={() => mutate(id)}
          opened={opened}
        />
      )}

      <ActionIcon
        variant="transparent"
        color="red"
        size="lg"
        radius={8}
        onClick={() => setOpened(true)}
      >
        <Trash2 size={16} />
      </ActionIcon>
    </>
  );
};

export default DeleteSurveyQuestionButton;
